import { getLoginUrl, getLogoutUrl } from '../auth'

/**
 * this function yields the URL to redirect to after logout
 * @return {String} the URL to redirect to after logout
 */
export const getLogoutRedirectUrl = (): string => {
  const { origin, pathname, search } = window.location
  return getLogoutUrl(getLoginUrl('', `${origin}${pathname}${search}`))
}

/**
 * this function yields the URL to redirect to after auth failure
 * @return {String} the URL to redirect to after auth failure
 */
export const getAuthFailureRedirectUrl = (): string => {
  const { origin, pathname, search } = window.location
  return getLoginUrl('', `${origin}${pathname}${search}`)
}
